import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'



import BoxButton from '../Layout/BoxButton'
import ModalCreateDocumento from '../../components/SolicitudServicio/ModalCreateDocumento'
import ModalSummaryDocumento from '../../components/SolicitudServicio/ModalSummaryDocumento'
import ModalCreateEntrega from '../../components/Documentos/ModalCreateEntrega'
import ModalAddFactura from '../../components/Documentos/ModalAddFactura'
import ModalLastFactura from '../../components/Documentos/ModalLastFactura'
import ModalAddAdicional from '../../components/Documentos/ModalAddAdicional'
import ModalSelectorFromList from '../../components/Shared/ModalSelectorFromList'


import ModalConfirmarAccion from '../../components/Shared/ModalConfirmarAccion'

import { isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers'




import {
    displayModalCreateDocumento,
} from '../../actions/solicitudservicio'


import { showHideModalSummary } from '../../actions/documentos'

class Documentos extends Component {
    buttonOption = (documento, index) => {
        if (documento.getIn(['aprobacion','estado']) === 2) {
            return <BoxButton size={ 12 } name="binoculars" onClick={ () => this.props.showHideModalSummary(true, documento.get('id'), `solicitudes/servicios/${this.props.id}`, 'ACTUALIZAR_SOLICITUD_SERVICIO') }/>
        } else {
            return <BoxButton size={ 12 } name="pencil" onClick={ () => this.props.displayModalCreateDocumento(true, 'Documento', 'edit', index) } disabled={ !isAllowedToViewComponent('responsable_compras', this.props.solicitudservicio) || documento.get('estado') === 0 }/>
        }
    }

	render() {

        const { id, solicitudservicio, enums, divisas } = this.props
        if (!id) return null  

		return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '23px' }}></th>
                                    <th style={{ width: '5%' }}>No.</th>
                                    <th style={{ width: '15%' }}>Proveedor</th>
                                    <th style={{ width: '9%' }}>Total</th>
                                    <th style={{ width: '11%' }}>Tipo documento</th>
                                    <th style={{ width: '10%' }}>Estado</th>
                                    <th style={{ width: '12%' }}>Fecha inicio (registro)</th>
                                    <th style={{ width: '7%' }}>Fecha entrega</th>
                                    <th>Servicios</th>
                                </tr>
                            </thead>
                            <tbody>
                                {   
                                    solicitudservicio.get('documentos').map((a, b) => {

                                        const moneda = a.getIn(['cotizacion','moneda'])
                                        const divisa = getDivisa(divisas, moneda)

                                        const valor_con_iva = a.get('detalles').reduce((a1, b1) => { a1 += b1.get('valor_con_iva') * b1.get('cantidad'); return a1 }, 0)

                                        return (
                                            <tr key={ `tr4[${a.get('id')}]` }>
                                                <td style={{ padding: '0' }}>{ this.buttonOption(a, b) }</td>
                                                <td>{ a.get('consecutivo') ? enums.documentos.tipos[a.get('tipo')].PREFIJO + a.get('consecutivo') : '' }</td>
                                                <td>{ a.getIn(['proveedore', 'nombre']) }</td>
                                                <td style={{ textAlign: 'right' }}>{ formatcoin( valor_con_iva, divisa.simbolo ) }</td>
                                                <td>{ enums.documentos.tipos[a.get('tipo')] ? enums.documentos.tipos[a.get('tipo')].NOMBRE : null }</td>
                                                <td>{ enums.documentos.estados[a.get('estado')] }</td>
                                                <td style={{ textAlign: 'right' }}>{ a.get('fecha_inicio') ? moment(a.get('fecha_inicio')).format('YYYY-MM-DD') : null }</td>
                                                <td style={{ textAlign: 'right' }}>{ a.get('fecha_entrega') ? moment(a.get('fecha_entrega')).format('YYYY-MM-DD') : null }</td>
                                                <td style={{ padding: '0' }}>
                                                    <table className="table table-condensed table-striped">
                                                        <tbody>
                                                        {
                                                            a.get('detalles').map((c, d) => {
                                                                return (
                                                                    <tr key={ `tr5[${a.get('id')}][${c.get('id')}]` }>
                                                                        <td className={ c.get('adicion_id') !== null ? 'adicional' : '' }>{ c.get('descripcion') }</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <ModalCreateDocumento />
                <ModalSummaryDocumento />
                <ModalCreateEntrega />
                <ModalAddFactura />
                <ModalLastFactura />
                <ModalAddAdicional tipo_solicitud={ solicitudservicio.get('tipo') } />
                <ModalSelectorFromList />
                <ModalConfirmarAccion />
            </div>
		)
	}
}




function mapStateToProps(state, ownProps) {
    return {
        id: state.solicitudservicio.get('id'),
        solicitudservicio: state.solicitudservicio.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}



function mapDispatchToProps(dispatch) {
    return {
        displayModalCreateDocumento: (show, title, mode, indexDocumento) => dispatch(displayModalCreateDocumento(show, title, mode, indexDocumento)),
        showHideModalSummary: (show, id, url, type) => dispatch(showHideModalSummary(show, id, url, type)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documentos)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/Documentos.jsx